import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import { parameterizeURL } from 'utils/parameterizeURL';

function getOrganization(params) {
  const url = parameterizeURL(ApiUrl.ORGANIZATION, params);
  return httpService.get(url);
}

function getOrganizationIdentity() {
  return httpService.get(ApiUrl.ORGANIZATION_IDENTITY);
}

const obj = { getOrganization, getOrganizationIdentity };

export default obj;
